import { render } from "./Homandkitches.vue?vue&type=template&id=90f715b2"
import script from "./Homandkitches.vue?vue&type=script&lang=js"
export * from "./Homandkitches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__